import { createReducer } from 'redux-create-reducer';
import {
  FILTER_CHANGE,
} from '../constants';

const initialState = {
  activeFilter: '',
  additionalValues: null,
};

export default createReducer(initialState, {
  [FILTER_CHANGE](state, { filterType, values, additionalValues }) {
    return {
      ...state,
      [filterType]: values,
      additionalValues: typeof additionalValues === 'function' ? additionalValues(state.additionalValues) : additionalValues,
    };
  }
});
